var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.39999C3.79086 2.39999 2 4.11922 2 6.23999V17.76C2 19.8807 3.79086 21.6 6 21.6H18C20.2091 21.6 22 19.8807 22 17.76V6.23999C22 4.11922 20.2091 2.39999 18 2.39999H6ZM14.4462 15.0946L14.8627 11.2482L15.2766 13.7226C15.3427 14.1182 15.6984 14.4092 16.1158 14.4092H18.8757C19.29 14.4092 19.6257 14.0868 19.6257 13.6892C19.6257 13.2916 19.29 12.9692 18.8757 12.9692H16.6698L15.5641 6.35804C15.4067 5.41648 13.9822 5.45439 13.8794 6.403L13.2702 12.0283L12.6783 10.2883C12.4073 9.49174 11.2114 9.55783 11.0374 10.379L10.2878 13.9163L9.55246 8.65309C9.42772 7.76033 8.10978 7.6914 7.8848 8.5659L6.75195 12.9692H5.12424C4.71003 12.9692 4.37424 13.2916 4.37424 13.6892C4.37424 14.0868 4.71003 14.4092 5.12424 14.4092H7.26095C7.65189 14.4092 7.99241 14.1533 8.08615 13.7889L8.52062 12.1001L9.31368 17.7763C9.44107 18.6881 10.798 18.732 10.9891 17.8306L12.0166 12.9818L12.7927 15.2635C13.0775 16.1008 14.3513 15.9707 14.4462 15.0946Z",
    fill: "#FDB426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.98d9fdb72539c3f7fafcab275799c32a.svg";
export { ForwardRef as ReactComponent };